module.exports = __webpack_public_path__ + "static/media/deactive_sound_icon.3057b9cd.svg";